<template>
  <div :style="{height:bodyHeight}" class="homeContent">
    <nav-bar :main-index="4"></nav-bar>
    <div class="imgBox">
      <img alt class="macImg" src="../assets/images/mac.png" />
      <img alt class="imgWhite" src="../assets/images/iphoneWhite.png" />
      <img alt class="imgBlack" src="../assets/images/iphoneBlack.png" />
      <video autoplay class="video" loop muted preload>
        <source :src="videoSrc" type="video/mp4" />
      </video>
    </div>
    <div class="shadowBox">
      <div>
        <div class="title wow fadeInRight" data-wow-duration="1s">技术连接全球, 资源整合世界</div>
      </div>
    </div>

    <div class="footer">
      <a href="https://beian.miit.gov.cn/" target="_blank">沪ICP备14018480号</a>
      <a
        href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502008819"
        target="_blank"
      >
        <img src="../assets/images/beian.png" /> 沪公网安备 31011502008819号
      </a>
      <br>
      版权所有©上海直达软件有限公司 
    </div>

    <img alt="港股，美股，期货" class="hiddenImg" src="../assets/images/homepageBg.png" />
  </div>
</template>

<script>
import navBar from "../components/navBar";

export default {
  name: "Home",
  data() {
    return {
      videoSrc: "static/appVideo.mov",
      bodyHeight: window.innerHeight - 105 + "px"
    };
  },
  beforeMount() {},
  mounted() {
    new this.$wow.WOW().init();
  },
  watch: {},
  methods: {},
  components: {
    navBar: navBar
  }
};
</script>

<style scoped>
.homeContent {
  opacity: 0.85;
  background-image: url(../assets/images/homepageBg.png);
  background-position-y: -78px;
  background-size: 100%;
  background-repeat: no-repeat;
}

.shadowBox {
  width: 751px;
  position: absolute;
  right: 0;
  top: 270px;
}

.shadowBox > div {
  width: 100%;
  height: 221px;
  /*background-color: rgba(31, 41, 59, 0.5);*/
  position: absolute;
  right: 0;
  top: 80px;
}

.title {
  height: 72px;
  font-size: 48px;
  font-family: Lantinghei SC;
  font-weight: 600;
  color: #fff;
  line-height: 70px;
  padding-top: 58px;
  margin-left: 60px;
  /* text-shadow: 0px 0px 3px #fff; */
}

.secondTitle {
  margin-top: 20px;
  height: 42px;
  font-size: 30px;
  font-family: Lantinghei SC;
  font-weight: bold;
  color: #ffa63e;
  margin-left: 60px;
}

/*.choiceBox {*/
/*  width: 100%;*/
/*  text-align: center;*/
/*  height: 80px;*/
/*  margin-top: 205px;*/
/*  padding-bottom: 40px;*/
/*}*/

span {
  display: inline-block;
  border: 1px solid #fff;
  box-sizing: border-box;
  width: 221px;
  height: 80px;
  line-height: 80px;
  font-size: 24px;
  font-family: Lantinghei SC;
  font-weight: 200;
  color: #ffffff;
  cursor: pointer;
  border-radius: 2px;
}

.active {
  background-color: rgba(255, 255, 255, 0.1);
  color: #ffa63e !important;
  border: 0;
  box-shadow: 0px 5px 9px 1px rgba(35, 24, 21, 0.1);
}

.slogan {
  transition: opacity 1s ease;
}

.imgBox {
  /*width: 50%;*/
  height: 588px;
  position: relative;
  left: 0;
  top: 200px;
  overflow-y: hidden;
}

.macImg {
  width: 618px;
  position: absolute;
  left: 160px;
}

.imgWhite {
  width: 160px;
  position: absolute;
  left: 680px;
  top: 185px;
}

.imgBlack {
  width: 253px;
  position: absolute;
  left: 880px;
  top: 0;
  z-index: 999;
}

.footer {
  width: 100%;
  text-align: center;
  position: fixed;
  bottom: 0;
  height: 59px;
  line-height: 22px;
  background: #21252b;
  opacity: 0.9;
  z-index: 999;
}

.footer a {
  color: #fff;
  text-decoration: none;
  align-items: center;
}

.footer a img {
  width: 20px;
  height: 20px;
}

.footer a:hover {
  color: #fff;
  text-decoration: underline;
}

.video {
  height: 480px;
  position: absolute;
  left: 896px;
  top: 14px;
}

/*1280的设备屏幕*/
@media (max-width: 1439px) {
  .imgBox {
    top: 160px;
  }
  .macImg {
    left: 50px;
    width: 500px;
  }
  .imgWhite {
    left: 475px;
    width: 130px;
    top: 140px;
  }
  .imgBlack {
    left: 635px;
    width: 200px;
  }
  .video {
    left: 648px;
    height: 379px;
    top: 11px;
  }
  .shadowBox {
    width: 450px;
  }
  .shadowBox > div {
    top: 0;
  }
  .shadowBox .title {
    font-size: 27px;
  }
}

/*1440的设备屏幕*/
@media (min-width: 1440px) and (max-width: 1679px) {
  .macImg {
    left: 80px;
    width: 560px;
  }
  .imgWhite {
    left: 568px;
    width: 128px;
  }
  .imgBlack {
    left: 720px;
    width: 222px;
  }
  .video {
    left: 735px;
    height: 420px;
    top: 12px;
  }
  .shadowBox {
    width: 482px;
  }
  .shadowBox .title {
    font-size: 32px;
  }
}

/*1680的设备屏幕*/
@media (min-width: 1680px) and (max-width: 1919px) {
  .macImg {
    left: 120px;
  }
  .imgWhite {
    left: 640px;
  }
  .imgBlack {
    left: 840px;
  }
  .video {
    left: 856px;
  }
  .shadowBox {
    width: 570px;
  }
  .shadowBox .title {
    font-size: 38px;
  }
}

/*1920的设备屏幕*/
@media (min-width: 1920px) {
}
</style>


// WEBPACK FOOTER //
// src/components/home.vue